export enum TinkLinkUrlParameter {
  /* Product agnostic parameters */
  CLIENT_ID = 'client_id',
  LOCALE = 'locale',
  MARKET = 'market',
  STATE = 'state',
  REDIRECT_URI = 'redirect_uri',
  SESSION_ID = 'session_id',
  AUTO_REDIRECT_MOBILE = 'auto_redirect_mobile',
  USER_CREDENTIALS_ID = 'credentials_id',
  THIRD_PARTY_CREDENTIALS_ID = 'credentialsId',
  IFRAME = 'iframe',
  /* Supposed to be used only by Mobile SDK to enable propagation of event messages - BANKX-449 */
  MOBILESDK = 'is_mobile_sdk',
  DEBUG = 'debug',
  APP_URI = 'app_uri',
  CALLBACK_URI = 'callback_uri',
  INPUT_USERNAME = 'input_username',
  THEME = 'theme',
  REFRESHABLE_ITEMS = 'refreshable_items',
  IS_NATIVE_NAVIGATION = 'is_native_navigation',
  /* Means for retrieving UAT */
  AUTHORIZATION_CODE = 'authorization_code',
  AUTHORIZATION_TOKEN = 'authorization_token',
  TRACKING_ID = 'tracking_id',
  HANDOFF_SESSION_ID = 'handoff_session_id',

  /**
   * This parameter is forwarded to https://docs.tink.com/api#connectivity-v1/credentials/refresh-credentials/query-parameters API call.
   * */
  OPT_IN = 'opt_in',

  /* Legacy parmameters */
  AUTHENTICATE = 'authenticate', // Permanent users
  SCOPE = 'scope', // Authorize, translated to refreshable items

  /* Provider related parameters */
  INPUT_PROVIDER = 'input_provider',
  FINANCIAL_INSTITUTION_ID = 'financial_institution_id',
  FINANCIAL_SERVICES_SEGMENTS = 'financial_services_segments',

  /* Reports parameters */
  EXTERNAL_REFERENCE = 'external_reference',
  ENGINE_VERSION = 'engine_version',
  CUSTOMER_REFERENCE_ID = 'customer_reference_id',
  REPORT_TYPES = 'report_types',
  ACCOUNT_DIALOG_TYPE = 'account_dialog_type',
  ASYNC = 'async',

  /* Payments query params */
  TRANSFER_ID = 'transferId',
  PAYMENT_REQUEST_ID = 'payment_request_id',
  BULK_PAYMENT_REQUEST_ID = 'bulk_payment_request_id',
  CONSENT_ID = 'consent_id',

  /* List of products included in query param */
  PRODUCTS = 'products',

  /* List of provider names that are connected in multibanking scenario */
  CONNECTED_PROVIDERS = 'connected_providers',

  /* Initial multibanking user */
  MULTIBANKING_USER = 'multibanking_user',
}
